<template>
    <section class="our-menu red lighten-5">
      <v-container >
        <h2 style="font-size: 17pt !important" class="text-center text-capitalize white--text text-caption h1 font-weight-bold mt-10 mb-6"
        >{{$t("home.MainMenu")}}</h2>
        <v-row
          class="fill-height mb-3"
          justify="center"
          >    <v-slide-group
              show-arrows
              dark
              v-if="categorieLoading"
              >
              <v-slide-item
              v-for="(btn, index) in numCategorie" :key="index"
              >
               <v-skeleton-loader
              class="mx-2 rounded-pill grey lighten-2"
              type="button"
               ></v-skeleton-loader>
              </v-slide-item>
              </v-slide-group>

              <v-slide-group
              v-show="!categorieLoading"
              v-model="activeMenu"
              show-arrows
              dark
              >
              <v-slide-item
              v-for="(categorie, index) in buttonsMenu" :key="index"
              >
              <v-btn light v-text="categorie[lang]" class="mx-2 rounded-pill"
              style="box-shadow:none"
              @click="getMenuData(categorie.id)" :class="categorie.id==activeMenu?'active-menu':''"
              ></v-btn>
              </v-slide-item>
              </v-slide-group>
          </v-row>
          <v-row>
          <v-col
            :md="4"
            :sm="12"
            :cols="12"
            class="flex-"
            v-for="(num, index) in numItems" :key="index"
            >
            <v-skeleton-loader
             v-if="loading"
              class="mx-auto white"
              max-width="370"
              :loading='false'
              type="image,article"
            ></v-skeleton-loader>  
          </v-col>  
          </v-row>      
        <div class="menu"
          
        >
        <!--v-for="(menuList, index) in this.$store.state.menuListes" :key="index"-->
        <v-row
          
        >
        <!--v-if="activeMenu==menuList.type"-->
         <v-col
         :md="4"
         :sm="12"
         :cols="12"
         class="flex-"
         v-for="(menu, index) in menuListes" :key="index"
         >
           <v-card
          max-width="400"
          class="mx-auto"
          height="300"
    >
      <div class="d-flex justify-center pt-3 align-center ">
      <v-badge
      :content="menu.discount+'% off'"
      overlap
      :value="menu.discount!=''"
      bottom
      offset-x="0"
      color="green"
      class="font-weight-bold"
      >
      <!--:src="require(`@/assets/food/${menuList.type}/${menu.img}`)"-->
      <v-img  :src="menu.img" alt="menu.title" 
          max-width="108"
          height="108"
          :contain="true"
          >
          <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
       </v-badge>
      </div>
      <v-card-title  class="red--text font-weight-bold" v-text="menu[lang].title"></v-card-title>
      <v-card-subtitle  class="pb-2 font-weight-bold">
      price :<span :class="menu.discount!='' ? 'text-decoration-line-through' :''"> {{menu.price}}$</span>
      <span class="ml-6 mr-6  grey white--text pa-1 pr-3 pl-3 rounded" v-if="menu.discount!=''">{{priceAfterDiscount(menu)}}$</span>
      </v-card-subtitle>
      <v-card-text class="text--primary">
        <div v-text="menu[lang].description"></div>
      </v-card-text>
    </v-card>
         </v-col>
        </v-row>
        </div>
      </v-container>
    </section>
</template>

<script>
import {menuMixing,lang} from '@/mixins/index'

export default {
    name:'main_menu',
    mixins:[menuMixing,lang],
    methods: {
        
        priceAfterDiscount(menu){
           return parseInt(menu.price) - (parseInt(menu.price)*parseInt(menu.discount))/100;
        }
    },
    beforeMount(){
      this.buttonLoading=true
    },
    mounted(){
      this.buttonLoading=false
    }
}
</script>

<style lang="scss" scoped>
  .our-menu{    
background: #fffbd5;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #b20a2c, #fffbd5);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #b20a2c, #fffbd5); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .active-menu{
    background-color: #000 !important;
    color: #fff !important;
  }
</style>